import { getAdmin } from "../../include/function";

const getUserMenuItems = (options = {}) => {
  const ignorePermissions = options?.ignorePermissions === true;
  const user = getAdmin();
  const isSuper = user.createdBy === "super";

  // Build a Map of page URLs to their permissions
  const pagePermissions = new Map();
  (user.roleProperties || []).forEach((rp) => {
    if (rp.pageUrl) {
      pagePermissions.set(rp.pageUrl, {
        view: rp.view === "true" || rp.view === 1,
        add: rp.add === "true" || rp.add === 1,
        edit: rp.edit === "true" || rp.edit === 1,
        delete: rp.delete === "true" || rp.delete === 1,
      });
    }
  });

  // Helper: check if user has ANY permission on a page
  const hasAnyPermission = (url) => {
    if (ignorePermissions || isSuper) return true;
    const perms = pagePermissions.get(url);
    return perms && (perms.view || perms.add || perms.edit || perms.delete);
  };

  // Helper: check if user has ADD permission on a page
  const hasAddPermission = (url) => {
    if (ignorePermissions || isSuper) return true;
    const perms = pagePermissions.get(url);
    return perms && perms.add;
  };

  let menuContent = [];

  menuContent.push({
    key: "general-title",
    isTitle: true,
    text: "GENERAL",
    className: "sidebar-title",
  });

  // Dashboard – always visible
  menuContent.push({
    key: "dashboard",
    url: "/admin/dashboard",
    isTitle: false,
    text: "Dashboard",
    Icon: "/assets/images/dash-icon1.png",
    hoverIcon: "/assets/images/dash-icon2.png",
  });

  // Home – assume always allowed
  menuContent.push({
    key: "home",
    url: "/admin/Content-homepage",
    isTitle: false,
    text: "Home",
    Icon: "/assets/images/dash-icon1.png",
    hoverIcon: "/assets/images/dash-icon2.png",
  });

  // --- Category ---
  const categoryChildren = [
    ...(hasAnyPermission("/admin/category/categoryList")
      ? [
          {
            key: "categoryList",
            url: "/admin/category/categoryList",
            isTitle: false,
            text: "List",
            parentKey: "category",
          },
        ]
      : []),
    ...(hasAddPermission("/admin/category/categoryList")
      ? [
          {
            key: "categoryAddNew",
            url: "/admin/category/categoryAddNew",
            isTitle: false,
            text: "Add New",
            parentKey: "category",
          },
        ]
      : []),
  ];
  if (categoryChildren.length > 0) {
    menuContent.push({
      key: "category",
      isTitle: false,
      text: "Category",
      Icon: "/assets/images/cat-icon1.png",
      hoverIcon: "/assets/images/cat-icon2.png",
      children: categoryChildren,
    });
  }

  // --- Brands ---
  const brandChildren = [
    ...(hasAnyPermission("/admin/brand/brandList")
      ? [
          {
            key: "brandList",
            url: "/admin/brand/brandList",
            isTitle: false,
            text: "List",
            parentKey: "brand",
          },
        ]
      : []),
    ...(hasAddPermission("/admin/brand/brandList")
      ? [
          {
            key: "brandAddNew",
            url: "/admin/brand/brandAddNew",
            isTitle: false,
            text: "Add New",
            parentKey: "brand",
          },
        ]
      : []),
  ];
  if (brandChildren.length > 0) {
    menuContent.push({
      key: "brand",
      isTitle: false,
      text: "Brands",
      Icon: "/assets/images/brand-icon1.png",
      hoverIcon: "/assets/images/brand-icon2.png",
      children: brandChildren,
    });
  }

  // --- Products ---
  const productChildren = [
    ...(hasAnyPermission("/admin/product/productList")
      ? [
          {
            key: "productList",
            url: "/admin/product/productList",
            isTitle: false,
            text: "List",
            parentKey: "product",
          },
        ]
      : []),
    ...(hasAddPermission("/admin/product/productList")
      ? [
          {
            key: "productAddNew",
            url: "/admin/product/productAddNew",
            isTitle: false,
            text: "Add New",
            parentKey: "product",
          },
        ]
      : []),
  ];
  if (productChildren.length > 0) {
    menuContent.push({
      key: "product",
      isTitle: false,
      text: "Products",
      Icon: "/assets/images/prod-icon1.png",
      hoverIcon: "/assets/images/prod-icon2.png",
      children: productChildren,
    });
  }

  // --- Sales ---
  const saleChildren = [
    ...(hasAnyPermission("/admin/sales/orders")
      ? [
          {
            key: "orders",
            url: "/admin/sales/orders",
            isTitle: false,
            text: "Orders",
            parentKey: "sale",
          },
        ]
      : []),
    ...(hasAnyPermission("/admin/sales/invoice")
      ? [
          {
            key: "invoice",
            url: "/admin/sales/invoice",
            isTitle: false,
            text: "Invoices",
            parentKey: "sale",
          },
        ]
      : []),
    ...(hasAnyPermission("/admin/sales/payment")
      ? [
          {
            key: "payment",
            url: "/admin/sales/payment",
            isTitle: false,
            text: "Payments",
            parentKey: "sale",
          },
        ]
      : []),
  ];
  if (saleChildren.length > 0) {
    menuContent.push({
      key: "sale",
      isTitle: false,
      text: "Sales",
      Icon: "/assets/images/sale-icon1.png",
      hoverIcon: "/assets/images/sale-icon2.png",
      children: saleChildren,
    });
  }

  // --- Content ---
  const contentChildren = [
    ...(hasAnyPermission("/admin/content/contentList")
      ? [
          {
            key: "contentList",
            url: "/admin/content/contentList",
            isTitle: false,
            text: "List",
            parentKey: "content",
          },
        ]
      : []),
    ...(hasAddPermission("/admin/content/contentList")
      ? [
          {
            key: "contentAddNew",
            url: "/admin/content/contentAddNew",
            isTitle: false,
            text: "Add New",
            parentKey: "content",
          },
        ]
      : []),
  ];
  if (contentChildren.length > 0) {
    menuContent.push({
      key: "content",
      isTitle: false,
      text: "Content",
      Icon: "/assets/images/cont-icon1.png",
      hoverIcon: "/assets/images/cont-icon2.png",
      children: contentChildren,
    });
  }

  // --- Delivery Charge ---
  const deliveryChildren = [
    ...(hasAnyPermission("/admin/deliveryCharge/deliveryChargeList")
      ? [
          {
            key: "deliveryChargeList",
            url: "/admin/deliveryCharge/deliveryChargeList",
            isTitle: false,
            text: "List",
            parentKey: "deliveryCharge",
          },
        ]
      : []),
    ...(hasAddPermission("/admin/deliveryCharge/deliveryChargeList")
      ? [
          {
            key: "deliveryChargeAddNew",
            url: "/admin/deliveryCharge/deliveryChargeAddNew",
            isTitle: false,
            text: "Add New",
            parentKey: "deliveryCharge",
          },
        ]
      : []),
  ];
  if (deliveryChildren.length > 0) {
    menuContent.push({
      key: "deliveryCharge",
      isTitle: false,
      text: "Delivery Charge",
      Icon: "/assets/images/del-icon1.png",
      hoverIcon: "/assets/images/del-icon2.png",
      children: deliveryChildren,
    });
  }

  // --- Pincode ---
  const pincodeChildren = [
    ...(hasAnyPermission("/admin/pincode/pincodeList")
      ? [
          {
            key: "pincodeList",
            url: "/admin/pincode/pincodeList",
            isTitle: false,
            text: "List",
            parentKey: "pincode",
          },
        ]
      : []),
    ...(hasAddPermission("/admin/pincode/pincodeList")
      ? [
          {
            key: "pincodeAddNew",
            url: "/admin/pincode/pincodeAddNew",
            isTitle: false,
            text: "Add New",
            parentKey: "pincode",
          },
        ]
      : []),
  ];
  if (pincodeChildren.length > 0) {
    menuContent.push({
      key: "pincode",
      isTitle: false,
      text: "Pincode",
      Icon: "/assets/images/del-icon1.png",
      hoverIcon: "/assets/images/del-icon2.png",
      children: pincodeChildren,
    });
  }

  // ======================
  // USER SECTION
  // ======================
  const userSectionItems = [
    hasAnyPermission("/admin/role/roleList"),
    hasAnyPermission("/admin/user/userList"),
    hasAnyPermission("/admin/coupon/couponList"),
    hasAnyPermission("/admin/customer/customerList"),
    hasAnyPermission("/admin/document/documentVerify"),
  ];

  if (userSectionItems.some(Boolean)) {
    menuContent.push({
      key: "general-user",
      isTitle: true,
      text: "USER",
      className: "sidebar-title",
    });

    // Roles
    const roleChildren = [
      ...(hasAnyPermission("/admin/role/roleList")
        ? [
            {
              key: "roleList",
              url: "/admin/role/roleList",
              isTitle: false,
              text: "List",
              parentKey: "role",
            },
          ]
        : []),
      ...(hasAddPermission("/admin/role/roleList")
        ? [
            {
              key: "roleAddNew",
              url: "/admin/role/roleAddNew",
              isTitle: false,
              text: "Add New",
              parentKey: "role",
            },
          ]
        : []),
    ];
    if (roleChildren.length > 0) {
      menuContent.push({
        key: "role",
        isTitle: false,
        text: "Roles",
        Icon: "/assets/images/rol-icon1.png",
        hoverIcon: "/assets/images/rol-icon2.png",
        children: roleChildren,
      });
    }

    // Users
    const userChildren = [
      ...(hasAnyPermission("/admin/user/userList")
        ? [
            {
              key: "userList",
              url: "/admin/user/userList",
              isTitle: false,
              text: "List",
              parentKey: "users",
            },
          ]
        : []),
      ...(hasAddPermission("/admin/user/userList")
        ? [
            {
              key: "userAddNew",
              url: "/admin/user/userAddNew",
              isTitle: false,
              text: "Add New",
              parentKey: "users",
            },
          ]
        : []),
    ];
    if (userChildren.length > 0) {
      menuContent.push({
        key: "users",
        isTitle: false,
        text: "Users",
        Icon: "/assets/images/user-icon1.png",
        hoverIcon: "/assets/images/user-icon2.png",
        children: userChildren,
      });
    }

    // Coupon
    const couponChildren = [
      ...(hasAnyPermission("/admin/coupon/couponList")
        ? [
            {
              key: "couponList",
              url: "/admin/coupon/couponList",
              isTitle: false,
              text: "List",
              parentKey: "coupon",
            },
          ]
        : []),
      ...(hasAddPermission("/admin/coupon/couponList")
        ? [
            {
              key: "couponAddNew",
              url: "/admin/coupon/couponAddNew",
              isTitle: false,
              text: "Add New",
              parentKey: "coupon",
            },
          ]
        : []),
    ];
    if (couponChildren.length > 0) {
      menuContent.push({
        key: "coupon",
        isTitle: false,
        text: "Coupon",
        Icon: "/assets/images/coup-icon1.png",
        hoverIcon: "/assets/images/coup-icon2.png",
        children: couponChildren,
      });
    }

    // Customers
    if (hasAnyPermission("/admin/customer/customerList")) {
      menuContent.push({
        key: "customer",
        url: "/admin/customer/customerList",
        isTitle: false,
        text: "Customers",
        Icon: "/assets/images/cus-icon1.png",
        hoverIcon: "/assets/images/cus-icon2.png",
      });
    }

    // Document Verify
    if (hasAnyPermission("/admin/document/documentVerify")) {
      menuContent.push({
        key: "documentVerify",
        url: "/admin/document/documentVerify",
        isTitle: false,
        text: "Document Verify",
        Icon: "/assets/images/doc-icon1.png",
        hoverIcon: "/assets/images/doc-icon2.png",
      });
    }
  }

  // ======================
  // OTHERS SECTION
  // ======================


  // const showLogsMenu =
  //   isSuper ||
  //   ignorePermissions ||
  //   !(user.roleProperties || []).length ||
  //   hasAnyPermission("/admin/logs");

  const reportChildren = [
    ...(hasAnyPermission("/admin/reports/reportSales")
      ? [
          {
            key: "reportSales",
            url: "/admin/reports/reportSales",
            isTitle: false,
            text: "Sales",
            parentKey: "reports",
          },
        ]
      : []),
    ...(hasAnyPermission("/admin/reports/reportProducts")
      ? [
          {
            key: "reportProducts",
            url: "/admin/reports/reportProducts",
            isTitle: false,
            text: "Products",
            parentKey: "reports",
          },
        ]
      : []),
    ...(hasAnyPermission("/admin/reports/reportCustomer")
      ? [
          {
            key: "reportCustomer",
            url: "/admin/reports/reportCustomer",
            isTitle: false,
            text: "Customer",
            parentKey: "reports",
          },
        ]
      : []),
  ];

  const notificationChildren = [
    ...(hasAnyPermission("/admin/notification/notificationList")
      ? [
          {
            key: "notificationList",
            url: "/admin/notification/notificationList",
            isTitle: false,
            text: "List",
            parentKey: "notification",
          },
        ]
      : []),
    ...(hasAddPermission("/admin/notification/notificationList")
      ? [
          {
            key: "notificationSendNew",
            url: "/admin/notification/notificationSendNew",
            isTitle: false,
            text: "Send New",
            parentKey: "notification",
          },
        ]
      : []),
  ];

  const othersItems = [
    reportChildren.length > 0,
    notificationChildren.length > 0,
    hasAnyPermission("/admin/logs"),
    hasAnyPermission("/admin/audit-log"),
    hasAnyPermission("/admin/loyalityPoints"),
    hasAnyPermission("/admin/settings"),
  ];

  if (othersItems.some(Boolean)) {
    menuContent.push({
      key: "others",
      isTitle: true,
      text: "OTHERS",
      className: "sidebar-title",
    });

    if (reportChildren.length > 0) {
      menuContent.push({
        key: "reports",
        isTitle: false,
        text: "Reports",
        Icon: "/assets/images/rep-icon1.png",
        hoverIcon: "/assets/images/rep-icon2.png",
        children: reportChildren,
      });
    }

    if (notificationChildren.length > 0) {
      menuContent.push({
        key: "notification",
        isTitle: false,
        text: "Notification",
        Icon: "/assets/images/not-icon1.png",
        hoverIcon: "/assets/images/not-icon2.png",
        children: notificationChildren,
      });
    }

    if (hasAnyPermission("/admin/loyalityPoints")) {
      menuContent.push({
        key: "loyalityPoints",
        url: "/admin/loyalityPoints",
        isTitle: false,
        text: "Loyality Points",
        Icon: "/assets/images/loyal-icon1.png",
        hoverIcon: "/assets/images/loyal-icon2.png",
      });
    }

    if (hasAnyPermission("/admin/settings")) {
      menuContent.push({
        key: "settings",
        url: "/admin/settings",
        isTitle: false,
        text: "Settings",
        Icon: "/assets/images/set-icon1.png",
        hoverIcon: "/assets/images/set-icon2.png",
      });
    }

    if (hasAnyPermission("/admin/logs")) {
      menuContent.push({
        key: "logs",
        url: "/admin/logs",
        isTitle: false,
        text: "Logs",
        Icon: "/assets/images/doc-icon1.png",
        hoverIcon: "/assets/images/doc-icon2.png",
      });
    }

    if (hasAnyPermission("/admin/audit-log")) {
      menuContent.push({
        key: "auditLog",
        url: "/admin/audit-log",
        isTitle: false,
        text: "Audit Log",
        Icon: "/assets/images/doc-icon1.png",
        hoverIcon: "/assets/images/doc-icon2.png",
      });
    }

  }

  return menuContent;
};

export default getUserMenuItems;

// Use this in Role/Permission screens to list ALL pages (even if current user can't see them).
export const getAllAdminMenuItems = () => getUserMenuItems({ ignorePermissions: true });
